export default {
    listeners: {
        click: true,
        contextmenu: true
    }
}